(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seo-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.rm-toggle');
  if (!btn) return;
  const content = btn.previousElementSibling;
  const expanded = btn.getAttribute('aria-expanded') === 'true';
  if (expanded) {
    content.classList.add('rm-collapsed');
    btn.setAttribute('aria-expanded','false');
    btn.textContent = btn.dataset.more;
  } else {
    content.classList.remove('rm-collapsed');
    btn.setAttribute('aria-expanded','true');
    btn.textContent = btn.dataset.less;
  }
});

  } catch(e) { console.error(e); }
})();
})();
